<div class="admin-container">

    <div>

        <div>
            <input type="number"
                   placeholder="grams"
                   #weight>
        </div>

        <div>
            @for (food of defaultFoods; track food)
            {
            <mat-card>
                <mat-card-content (click)="logFood(food, weight.value)">
                    {{food}}
                </mat-card-content>

            </mat-card>
        }
        </div>

    </div>

    <div>
        <input type="text"
               placeholder="new food"
               #food>

    </div>

</div>
